export const DEFAULT_WARRANTY_PERIOD = "5Y";

export const WARRANTY_PERIOD_OPTIONS = [
  { value: "3M", label: "3 Months" },
  { value: "1Y", label: "1 Year" },
  { value: "5Y", label: "5 Years" },
];

const WARRANTY_PERIOD_MONTHS = {
  "3M": 3,
  "1Y": 12,
  "5Y": 60,
};

export const isSupportedWarrantyPeriod = (period) =>
  Object.prototype.hasOwnProperty.call(WARRANTY_PERIOD_MONTHS, period);

export const toWarrantyDate = (value) => {
  if (!value) return null;

  const source = value.toDate ? value.toDate() : value;

  if (typeof source === "string") {
    const dateOnlyMatch = source.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
      const year = Number(dateOnlyMatch[1]);
      const month = Number(dateOnlyMatch[2]) - 1;
      const day = Number(dateOnlyMatch[3]);
      const date = new Date(year, month, day);

      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month ||
        date.getDate() !== day
      ) {
        return null;
      }

      return date;
    }
  }

  const date = source instanceof Date ? new Date(source.getTime()) : new Date(source);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatWarrantyDate = (value) => {
  const date = toWarrantyDate(value);
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const calculateWarrantyEndDate = (period, startDate) => {
  if (!isSupportedWarrantyPeriod(period)) return null;

  const start = toWarrantyDate(startDate);
  if (!start) return null;

  const monthOffset = WARRANTY_PERIOD_MONTHS[period];
  const targetMonthIndex = start.getMonth() + monthOffset;
  const targetYear = start.getFullYear() + Math.floor(targetMonthIndex / 12);
  const targetMonth = targetMonthIndex % 12;
  const lastDayOfTargetMonth = new Date(
    targetYear,
    targetMonth + 1,
    0,
  ).getDate();

  return new Date(
    targetYear,
    targetMonth,
    Math.min(start.getDate(), lastDayOfTargetMonth),
  );
};
